import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledSubtitle = styled.span`
    display: flex;
    align-items: center;
    margin-top: 2.5rem;
    margin-bottom: 4.6rem;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    color: var(--color-grey-800);
    @media ${breakpoints.xs} {
        margin-top: 1.5rem;
        margin-bottom: 2.8rem;
        font-size: var(--size-10);
    }
`;

export const StyledAddMember = styled.div`
    margin-top: 6rem;
    @media ${breakpoints.xs} {
        margin-top: 2rem;
    }

    .MuiFormLabel-root {
        line-height: 2.4rem;
    }

    .addMemberRow {
        display: flex;
        justify-content: center;
        @media ${breakpoints.sm} {
            justify-content: space-around;
        }
        @media ${breakpoints.xs} {
            display: block;
        }

        .addMemberCol {
            @media ${breakpoints.mdMax} {
                width: 50%;
                &:first-child {
                    margin-right: 40px;
                }
            }
            @media ${breakpoints.sm} {
                width: 50%;
                &:first-child {
                    margin-right: 1.5%;
                }
            }
            @media ${breakpoints.xs} {
                width: 100%;
                &:first-child {
                    margin-right: 0;
                }
            }
            @media ${breakpoints.md} {
                width: 50%;
                &:first-child {
                    margin-right: 62px;
                }
            }
            @media ${breakpoints.lg} {
                width: 50%;
                &:first-child {
                    margin-right: 72px;
                }
            }
        }
    }
`;
